import React from 'react';
import t from 'prop-types';

var BotoneraAreaImagenVisor = function BotoneraAreaImagenVisor(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'botoneraAreaImagenVisorImagenes'
  }, children);
};

BotoneraAreaImagenVisor.propTypes = process.env.NODE_ENV !== "production" ? {
  children: t.any
} : {};
export default BotoneraAreaImagenVisor;